import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { themes } from "segments/segments-service";
import PersonalTextualInfo from "segments/desktop/core-components/person-textual-info/person-textual-info";
import Picture from "/components/core/picture/picture-component";
import classnames from "classnames";
import testimonialCardDefaultProps from "./default-props";
import StyledTestimonialCardComponent from "./testimonial-card-component.scss";
class TestimonialCardComponent extends PureComponent {
    getThemeStyle() {
        const { theme } = this.props;
        return themes[theme] || {};
    }
    getQuoteInlineStyle() {
        const { fontSize, titleSize } = this.props;
        const inlineStyles = {};
        if (!titleSize) inlineStyles.fontSize = fontSize;
        return inlineStyles;
    }
    render() {
        const { quote, name, jobDescription, companyImage, titleSize, alt } = this.props;
        const themeStyle = this.getThemeStyle();
        const quoteInlineStyle = this.getQuoteInlineStyle();
        return /*#__PURE__*/ _jsxs(StyledTestimonialCardComponent, {
            className: "testimonial-card-component",
            style: themeStyle,
            children: [
                companyImage && /*#__PURE__*/ _jsx("div", {
                    className: "company-image-wrapper",
                    children: /*#__PURE__*/ _jsx(Picture, {
                        src: companyImage,
                        alt: alt
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "testimonial-card-content-wrapper",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: classnames("quote-wrapper", titleSize),
                            dangerouslySetInnerHTML: {
                                __html: quote
                            },
                            style: quoteInlineStyle
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "person-details-wrapper",
                            children: /*#__PURE__*/ _jsx(PersonalTextualInfo, {
                                name: name,
                                jobDescription: jobDescription,
                                color: themeStyle.color
                            })
                        })
                    ]
                })
            ]
        });
    }
}
export { TestimonialCardComponent as default };
TestimonialCardComponent.defaultProps = testimonialCardDefaultProps;
